module.exports = __webpack_public_path__ + "static/media/shoesbig22.b5d98ae4.jpg";